"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledBadge = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const Responsive_1 = require("../../shared/Responsive");
const getBackgroundColor = ({ $color = "red", $luminosity, }) => {
    const isHighLum = $luminosity === "high";
    if ($color === "greyscale") {
        return isHighLum ? "var(--ds-color-silver)" : "var(--ds-color-zinc)";
    }
    // "purple" need to use 130 for AA contrast ratio
    const colorLowLum = $color === "purple" ? 130 : 100;
    return isHighLum
        ? `var(--ds-color-${$color}-25)`
        : `var(--ds-color-${$color}-${colorLowLum})`;
};
const getBorderRadius = ({ $radius }) => {
    return $radius === "round" ? "9999px" : "var(--ds-border-radius)";
};
const getColor = ({ $color, $luminosity }) => {
    // "yellow" & "orange" uses "night" for AA contrast ratio
    return $luminosity === "high" || $color === "yellow" || $color === "orange"
        ? "var(--ds-color-night)"
        : "var(--ds-color-white)";
};
const getSize = ({ $size = "medium" }) => {
    const mappingCss = {
        small: {
            padding: "0px 4px",
            "min-height": "20px", // handles Badge without text (ie: Icon)
        },
        medium: {
            padding: "2px 8px",
            "min-height": "24px", // handles Badge without text (ie: Icon)
        },
    };
    return (0, Responsive_1.responsiveMapToMedia)($size, mappingCss);
};
exports.StyledBadge = styled_components_1.default.span `
    display: inline-flex;
    align-items: center;
    justify-content: center;
    position: relative;

    font-size: 0.875rem;
    font-family: var(--ds-font-family);
    font-weight: 700;
    line-height: 1.25rem;

    background-color: ${getBackgroundColor};
    border-radius: ${getBorderRadius};
    color: ${getColor};
    ${getSize}
    gap: 0.25rem; /* handles Badges with several children (ie: Icon + text) */

    /* Styling Icon size and color */
    --ds-icon-size: 1rem;
    --ds-icon-color: ${getColor};
`;
//# sourceMappingURL=Badge.styles.js.map